// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// --- RequestQueue ---
// Based on:
/*! jQuery Ajax Queue - v0.1.2pre - 2013-03-19
 * https://github.com/gnarf37/jquery-ajaxQueue
 * Copyright (c) 2013 Corey Frang; Licensed MIT
 */

// jQuery on an empty object, we are going to use this as our Queue
import $ from 'jquery';
import AppDispatcher from 'app_dispatcher';
import Config from 'config/config';
import { isEmpty } from 'lodash';

const ajaxQueue = $({});

const enqueueRequest = function (ajaxOpts) {
  let jqXHR = undefined;
  const dfd = $.Deferred();
  const promise = dfd.promise();
  // queue our ajax request
  // run the actual query
  if (isEmpty(ajaxOpts.headers)) {
    ajaxOpts.headers = {};
  }
  ajaxOpts.headers['X-ORIGIN-KEY'] = Config.apiKey;

  const doRequest = function (next) {
    jqXHR = $.ajax(ajaxOpts);
    jqXHR.done(dfd.resolve).fail(dfd.reject).then(next, next);
  };

  ajaxQueue.queue(doRequest);
  // add the abort method

  promise.abort = function (statusText) {
    // proxy abort to the jqXHR if it is active
    if (jqXHR) {
      return jqXHR.abort(statusText);
    }
    // if there wasn't already a jqXHR we need to remove from queue
    const queue = ajaxQueue.queue();
    const index = $.inArray(doRequest, queue);
    if (index > -1) {
      queue.splice(index, 1);
    }
    // and then reject the deferred
    dfd.rejectWith(ajaxOpts.context || ajaxOpts, [promise, statusText, '']);
    return promise;
  };

  return promise;
};

// ---
// generated by js2coffee 2.1.0

const RequestQueue = {
  get(url, data) {
    return this.enqueue(url, data, 'GET');
  },
  put(url, data) {
    return this.enqueue(url, data, 'PUT');
  },
  post(url, data) {
    return this.enqueue(url, data, 'POST');
  },
  delete(url, data) {
    return this.enqueue(url, data, 'DELETE');
  },
  enqueue(url, data, method) {
    if (ajaxQueue.queue().length === 0) {
      AppDispatcher.trigger('RequestQueue:busy');
    } //First request
    return enqueueRequest({
      method,
      url,
      data,
    })
      .done(function () {
        if (ajaxQueue.queue().length <= 1) {
          AppDispatcher.trigger('RequestQueue:ready');
        }
      })
      .fail(() => AppDispatcher.trigger('RequestQueue:fail'));
  },
};

export default RequestQueue;
